/**
 * Release Notes
 *
 * Imports changelog markdown at build time and converts to HTML.
 */

import changelog from '../public/release-notes/changelog.md'

/**
 * Simple markdown-to-HTML converter for changelog format.
 * Handles: ## headings, - list items, **bold**, blank lines
 */
function markdownToHtml(md: string): string {
    const lines = md.split('\n')
    const htmlLines: string[] = []
    let inList = false

    const bold = (text: string) => text.replace(/\*\*(.+?)\*\*/g, '<b>$1</b>')

    const closeList = () => {
        if (inList) {
            htmlLines.push('</ul>')
            inList = false
        }
    }

    for (const line of lines) {
        const trimmed = line.trim()

        if (trimmed.startsWith('## ')) {
            closeList()
            htmlLines.push(`<h2>${trimmed.slice(3).trim()}</h2>`)
        } else if (trimmed.startsWith('- ')) {
            if (!inList) {
                htmlLines.push('<ul>')
                inList = true
            }
            htmlLines.push(`<li>${bold(trimmed.slice(2).trim())}</li>`)
        } else if (!trimmed) {
            closeList()
        } else {
            closeList()
            htmlLines.push(`<p>${bold(trimmed)}</p>`)
        }
    }

    closeList()
    return htmlLines.join('\n')
}

// Pre-converted HTML, available immediately at import time
export const changelogHtml = markdownToHtml(changelog)
